module.exports = "/static-assets/_next/static/images/reveal-00f9c2aaa10ff2c1fbe769f2918978cd.png";